export default __webpack_public_path__ + "static/media/Icon_Search.a48bf2bc.svg";